import { isOpenQuoteAndOrderCalendarModal } from "@/atoms/is-open-quote-and-order-calendar-modal";
import { formatDateToYYYYMMDD } from "@/common/util/date-util";
import { useRecoilState } from "recoil";
import { Footnote12Description } from "../typography/Footnote12Description";

export const DurationDateText = () => {
  const [modal, setModal] = useRecoilState(isOpenQuoteAndOrderCalendarModal);

  if (!(modal.startDate && modal.endDate)) {
    return null;
  }

  return (
    <div className="flex items-center">
      <Footnote12Description className="text-semantic-success-success-text">
        {`${formatDateToYYYYMMDD(modal.startDate)} ~ ${formatDateToYYYYMMDD(
          modal.endDate
        )}`}
      </Footnote12Description>
    </div>
  );
};
